"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormImportCtrl = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var notification_service_1 = require("../../components/notification.toast/notification.service");
var i18n_1 = require("../../i18n");
var services_1 = require("../../services");
var mobx_2 = require("../../state/mobx");
var store_1 = require("../../store");
var upload_reader_1 = require("../../util/upload.reader");
var FormImportCtrl = /** @class */ (function (_super) {
    tslib_1.__extends(FormImportCtrl, _super);
    function FormImportCtrl() {
        var _this = _super.call(this) || this;
        _this.file = null;
        _this.isActive = false;
        _this.secondaryFormId = null;
        _this.fileId = 'file-' + core_shared_1.IkeId.generate();
        return _this;
    }
    FormImportCtrl.prototype.reset = function () {
        this.file = null;
    };
    FormImportCtrl.prototype.openFileDialog = function (e) {
        e.preventDefault();
        var fileInput = document.getElementById(this.fileId);
        if (fileInput == null) {
            throw new Error('Unable to find file input: "' + this.fileId + '\'');
        }
        var evt = document.createEvent('MouseEvents');
        evt.initEvent('click', true, false);
        fileInput.dispatchEvent(evt);
    };
    FormImportCtrl.prototype.onFile = function (e) {
        var fileInput = e.target;
        if (fileInput == null) {
            throw new Error('Unable to find file input: "' + this.fileId + '\'');
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.FormImportUpload, 'file:click', 'button', 1);
        this.loadFiles(fileInput.files);
    };
    FormImportCtrl.prototype.loadFiles = function (files) {
        this.file = null;
        if (!files || files.length === 0) {
            return;
        }
        var file = files[0];
        var hasAllowedSuffix = FormImportCtrl.ALLOWED_SUFFIXES.some(function (suffix) { return file.name.endsWith(suffix); });
        if (!hasAllowedSuffix) {
            notification_service_1.NotificationService.error({ key: i18n_1.T.FILE_NOT_SUPPORTED });
            return;
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.FormImportUpload, 'file:count', '1', 1);
        this.file = new upload_reader_1.UniversalFileUploadReader(file, undefined);
    };
    FormImportCtrl.prototype.processFile = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest, attachment, regexPattern, regex, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.file && this.file.buffer)) return [3 /*break*/, 7];
                        rest = services_1.Services.Department.rest;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, rest.Attachment.set(this.file.name, this.file.buffer, this.file.type)];
                    case 2:
                        attachment = _a.sent();
                        return [4 /*yield*/, rest.Attachment.antivirusScan(attachment.objectId)];
                    case 3:
                        _a.sent();
                        regexPattern = FormImportCtrl.REPLACED_SUFFIXES.map(function (suffix) { return '\\' + suffix; }).join('|');
                        regex = new RegExp(regexPattern, 'g');
                        return [4 /*yield*/, rest.Form.Pla.import(tslib_1.__assign({ attachmentId: attachment.objectId, name: attachment.name.replace(regex, '') }, (this.secondaryFormId && { revision: this.secondaryFormId })))];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, store_1.AppStore.FormSummary.refresh()];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        e_1 = _a.sent();
                        notification_service_1.NotificationService.error({ key: i18n_1.T.ERROR_GENERAL });
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    FormImportCtrl.COMMON_SUFFIXES = ['.csv', '.db', '.lccfg', '.client'];
    FormImportCtrl.ALLOWED_SUFFIXES = tslib_1.__spreadArray(tslib_1.__spreadArray([], FormImportCtrl.COMMON_SUFFIXES, true), ['.xlsx'], false);
    FormImportCtrl.REPLACED_SUFFIXES = tslib_1.__spreadArray(tslib_1.__spreadArray([], FormImportCtrl.COMMON_SUFFIXES, true), ['.poleforeman.xlsx'], false);
    tslib_1.__decorate([
        mobx_1.observable.shallow
    ], FormImportCtrl.prototype, "file", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FormImportCtrl.prototype, "isActive", void 0);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], FormImportCtrl.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], FormImportCtrl.prototype, "openFileDialog", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], FormImportCtrl.prototype, "onFile", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], FormImportCtrl.prototype, "processFile", null);
    return FormImportCtrl;
}(mobx_2.MobxState));
exports.FormImportCtrl = FormImportCtrl;
//# sourceMappingURL=form.import.ctrl.js.map